
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.844 0A2.847 2.847 0 000 2.844V29c0 1.566 1.43 3 3 3h4.094c.476 2.836 2.937 5 5.906 5s5.43-2.164 5.906-5h9.25A2.849 2.849 0 0031 29.156V2.906C31 1.305 29.738 0 28.187 0H2.845zM33 7v25c.48 2.832 3.031 5 6 5s5.43-2.168 5.906-5H47c1.57 0 3-1.43 3-3v-9.625c0-2.012-1.45-4.066-1.625-4.313L44.219 9.5C43.266 8.352 41.769 7 40 7h-7zm5 5h5.594l3.187 4.25c.34.48 1.219 1.953 1.219 3.125V20H38c-1 0-2-1-2-2v-4c0-1.105 1-2 2-2zM13 27c2.207 0 4 1.793 4 4s-1.793 4-4 4-4-1.793-4-4 1.793-4 4-4zm26 0c2.207 0 4 1.793 4 4s-1.793 4-4 4-4-1.793-4-4 1.793-4 4-4z","fill":"#000"}})])
          )
        }
      }
    